export default __webpack_public_path__ + "static/media/feature_image_1.6f7a1e23.webp";